import { useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { BilanzKarte } from '../components/EventTeilnahme.jsx';

/**
 * "Was die Events gebracht haben" — der Rückblick.
 *
 * Absichtlich nicht nur eine Liste von Zahlen: Ohne Maßstab sagt "+184
 * gefangen" nichts. Verglichen wird mit der eigenen normalen Spielrate, und
 * wenn die noch nicht messbar ist, sagt die Seite das, statt einen Vergleich
 * zu erfinden.
 */
export default function EventBilanzPage() {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);

  const holen = () =>
    api.teilnahme.uebersicht().then(setDaten).catch((e) => setFehler(e.message));

  useEffect(() => { holen(); }, []);

  const notizSpeichern = async (id, notiz) => {
    await api.teilnahme.aendern(id, { notiz });
    holen();
  };

  if (fehler) return <div className="error">{fehler}</div>;
  if (!daten) return <div className="skeleton" style={{ height: 200 }} />;

  const { laufend, historie, bestmarke, massstab, gesamt } = daten;

  if (!laufend && historie.length === 0) {
    return (
      <div className="panel panel--prose">
        <p>
          Noch keine Teilnahme aufgezeichnet. Auf jeder Event-Seite steht der
          Knopf <strong>„Ich bin dabei“</strong>. Danach einmal die
          Aktivitätsstatistik scannen, am Ende noch einmal — mehr ist es nicht.
        </p>
        <p className="card__meta">
          Gespeichert wird nur der Zeitraum. Die Zahlen kommen aus den Scans,
          die du ohnehin machst.
        </p>
      </div>
    );
  }

  return (
    <>
      {laufend && (
        <section className="section">
          <h2 className="section__title">Läuft gerade</h2>
          <BilanzKarte bilanz={laufend} onNotiz={notizSpeichern} />
        </section>
      )}

      {historie.length > 0 && (
        <section className="section">
          <h2 className="section__title">Deine Events</h2>

          {/* Die Leiste ist der Teil zum Herzeigen: nicht ein Event, sondern
              alles zusammen. Deshalb steht sie vor den Einzelkarten. */}
          <div className="ruhmesleiste">
            <div className="ruhmesleiste__zahl">
              <strong>{gesamt.events}</strong>
              <span>{gesamt.events === 1 ? 'Event mitgemacht' : 'Events mitgemacht'}</span>
            </div>
            <div className="ruhmesleiste__zahl">
              <strong>{gesamt.stunden.toLocaleString('de-DE')}</strong>
              <span>Stunden unterwegs</span>
            </div>
            {gesamt.gefangen > 0 && (
              <div className="ruhmesleiste__zahl">
                <strong>{gesamt.gefangen.toLocaleString('de-DE')}</strong>
                <span>Fänge dabei</span>
              </div>
            )}
            {gesamt.gescannt > 0 && (
              <div className="ruhmesleiste__zahl">
                <strong>{gesamt.gescannt.toLocaleString('de-DE')}</strong>
                <span>Exemplare bewertet</span>
              </div>
            )}
            {gesamt.shiny > 0 && (
              <div className="ruhmesleiste__zahl ruhmesleiste__zahl--gold">
                <strong>{gesamt.shiny}</strong>
                <span>Shiny</span>
              </div>
            )}
          </div>

          <p className="gruppe__text">
            {massstab.gefangen !== null ? (
              <>
                Gemessen an deiner normalen Spielrate von etwa{' '}
                <strong>{massstab.gefangen.toLocaleString('de-DE')} Fängen pro Stunde</strong>.
                {bestmarke && (
                  <> Bestes Event bisher: „{bestmarke.titel}“ mit {bestmarke.faktor.toLocaleString('de-DE')}×.</>
                )}
              </>
            ) : (
              <>
                Für einen Vergleich fehlen noch normale Spielstrecken — scanne
                die Statistik auch mal außerhalb eines Events, dann bekommen
                diese Zahlen einen Maßstab.
              </>
            )}
          </p>

          <div className="stack">
            {historie.map((b) => (
              <BilanzKarte key={b.id} bilanz={b} onNotiz={notizSpeichern} />
            ))}
          </div>
        </section>
      )}
    </>
  );
}
